import { useCompanyFlow } from "@/hooks/useCompanyFlow";
import { AddCardOneClick as AddCardOneClickBase } from "@/components/AddCardOneClick";

export const AddCardOneClick = () => {
  const { getCompanyRoute } = useCompanyFlow();

  return <AddCardOneClickBase returnPath={getCompanyRoute("cart")} />;
};
